import axios from 'axios'
import rivets from 'rivets'

class Instagram {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            token: false,
            dontInit: false,
            limit: 12 // changing this value will require modifications to the responsive css
        }, JSON.parse(this.elem.dataset.options ? this.elem.dataset.options : '{}'))

        this.elem.removeAttribute('data-options')
        this.template = this.elem.querySelector('[data-template]')

        if (!this.options.dontInit) {
            this.init()
        }
    }

    getInstagramPosts () {
        return axios.get(`https://api.instagram.com/v1/users/self/media/recent/?access_token=${this.options.token}&count=${this.options.limit}`)
    }

    onInit () {
        var test = document.querySelectorAll('.flex-grid li')

        test.forEach((e, i) => {
            e.setAttribute('id', 'item' + (i + 1))
        })
    }

    rivetsBinders () {
        rivets.binders['background'] = (el, value) => {
            el.style.setProperty('background-image', `url('${value}')`)
        }
    }

    async init () {
        this.rivetsBinders()
        let instaResponse = await this.getInstagramPosts()
        console.log(instaResponse.data.data)
        rivets.bind(this.template, {posts: instaResponse.data.data})
    }
}

export default Instagram



// WEBPACK FOOTER //
// ./resources/scripts/components/Instagram.js